"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Project = require("./Project");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * FormCell - Composant formulaire responsive
 */const FormCell = ({
  fields = [],
  action_log,
  link_to,
  styles_properties = {},
  className = '',
  style = {},
  onSubmit,
  submitText = 'Envoyer',
  submitStyles = {},
  onActionLog,
  initialValues = {},
  ...rest
}) => {
  // Contexte pour la navigation
  const projectContext = (0, _react.useContext)(_Project.ProjectContext);

  // État du formulaire
  const [formData, setFormData] = (0, _react.useState)(() => {
    const initial = {
      ...initialValues
    };
    fields.forEach(field => {
      if (!(field.name in initial)) {
        initial[field.name] = field.type === 'checkbox' ? false : '';
      }
    });
    return initial;
  });
  const [errors, setErrors] = (0, _react.useState)({});

  // Styles du conteneur
  const containerStyle = {
    backgroundColor: styles_properties.background_color,
    color: styles_properties.text_color,
    fontSize: styles_properties.text_size ? `${styles_properties.text_size}px` : undefined,
    fontFamily: styles_properties.text_font,
    borderRadius: styles_properties.border_radius ? `${styles_properties.border_radius}px` : undefined,
    borderColor: styles_properties.border_color,
    borderWidth: styles_properties.border_width ? `${styles_properties.border_width}px` : undefined,
    borderStyle: styles_properties.border_style,
    padding: styles_properties.padding ? `${styles_properties.padding}px` : undefined,
    opacity: styles_properties.opacity,
    textAlign: styles_properties.text_align,
    ...style
  };

  // Générer les styles pour un champ
  const getFieldStyle = field => {
    const props = field.style_properties || {};
    return {
      backgroundColor: props.background_color || '#ffffff',
      color: props.text_color,
      fontSize: props.text_size ? `${props.text_size}px` : undefined,
      fontFamily: props.text_font,
      borderRadius: props.border_radius ? `${props.border_radius}px` : undefined,
      borderColor: props.border_color || '#ccc',
      borderWidth: props.border_width ? `${props.border_width}px` : '1px',
      borderStyle: props.border_style || 'solid',
      padding: props.padding ? `${props.padding}px` : undefined,
      textAlign: props.text_align
    };
  };

  // Gestionnaire de changement
  const handleChange = (0, _react.useCallback)(e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Effacer l'erreur du champ modifié
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = {
          ...prev
        };
        delete newErrors[name];
        return newErrors;
      });
    }
  }, [errors]);

  // Validation
  const validate = (0, _react.useCallback)(() => {
    const newErrors = {};
    fields.forEach(field => {
      if (field.required) {
        const value = formData[field.name];
        if (value === '' || value === null || value === undefined) {
          newErrors[field.name] = `${field.label || field.name} est requis`;
        }
      }
      // Validation email basique
      if (field.type === 'email' && formData[field.name]) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData[field.name])) {
          newErrors[field.name] = 'Email invalide';
        }
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [fields, formData]);

  // Soumission
  const handleSubmit = e => {
    e.preventDefault();
    if (!validate()) return;

    // Log de l'action
    if (action_log && onActionLog) {
      onActionLog(action_log);
    }

    // Callback de soumission
    if (onSubmit) {
      logEvent();
    }

    // Redirection si définie
    if (link_to) {
      if (link_to.startsWith('http')) {
        window.open(link_to, '_blank');
      } else if (projectContext?.navigateToPage) {
        projectContext.navigateToPage(link_to);
      }
    }
  };

  // Rendu d'un champ
  const renderField = field => {
    const fieldStyle = getFieldStyle(field);
    const commonProps = {
      id: field.id,
      name: field.name,
      required: field.required,
      placeholder: field.placeholder,
      value: formData[field.name] || '',
      onChange: handleChange,
      style: fieldStyle
    };
    switch (field.type) {
      case 'textarea':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("textarea", {
          ...commonProps,
          className: "form-cell__textarea"
        });
      case 'select':
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
          ...commonProps,
          className: "form-cell__select",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            value: "",
            children: field.placeholder || 'Sélectionner...'
          }), (field.options || []).map(option => /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            value: option.value,
            children: option.label
          }, option.id))]
        });
      case 'checkbox':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "form-cell__checkbox-group",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
            className: "form-cell__checkbox-item",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
              type: "checkbox",
              id: field.id,
              name: field.name,
              checked: formData[field.name] || false,
              onChange: handleChange
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: field.placeholder || field.label
            })]
          })
        });
      case 'radio':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "form-cell__radio-group",
          children: (field.options || []).map(option => /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
            className: "form-cell__radio-item",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
              type: "radio",
              name: field.name,
              value: option.value,
              checked: formData[field.name] === option.value,
              onChange: handleChange
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: option.label
            })]
          }, option.id))
        });
      default:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          ...commonProps,
          type: field.type || 'text',
          className: "form-cell__input"
        });
    }
  };

  // Trier les champs par index
  const sortedFields = [...fields].sort((a, b) => (a.index || 0) - (b.index || 0));
  const containerClasses = ['form-cell', className].filter(Boolean).join(' ');

  // Styles du bouton submit
  const submitButtonStyle = {
    backgroundColor: submitStyles.background_color || '#007bff',
    color: submitStyles.text_color || '#ffffff',
    fontSize: submitStyles.text_size ? `${submitStyles.text_size}px` : undefined,
    fontFamily: submitStyles.text_font,
    borderRadius: submitStyles.border_radius ? `${submitStyles.border_radius}px` : '4px',
    borderColor: submitStyles.border_color,
    borderWidth: submitStyles.border_width ? `${submitStyles.border_width}px` : undefined,
    borderStyle: submitStyles.border_style || 'none'
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: containerClasses,
    style: containerStyle,
    ...rest,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
      className: "form-cell__form",
      onSubmit: handleSubmit,
      children: [sortedFields.map(field => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "form-cell__field",
        children: [field.label && field.type !== 'checkbox' && /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
          className: "form-cell__label",
          htmlFor: field.id,
          children: [field.label, field.required && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              color: '#dc3545'
            },
            children: " *"
          })]
        }), renderField(field), errors[field.name] && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "form-cell__error",
          style: {
            color: '#dc3545',
            fontSize: '0.85rem',
            marginTop: '4px'
          },
          children: errors[field.name]
        })]
      }, field.id)), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "submit",
        className: "form-cell__submit",
        style: submitButtonStyle,
        children: submitText
      })]
    })
  });
};
var _default = exports.default = FormCell;